module.exports = __webpack_public_path__ + "img/MT.0c830dd6.png";